import { defineMessages } from 'gatsby-plugin-react-intl';

const messages = defineMessages({
  'prospectus.global.attribute.description': {
    id: 'prospectus.global.attribute.description',
    description: 'Description of a course or program',
    defaultMessage: 'Description',
  },
  'prospectus.global.attribute.instructor-paced': {
    id: 'prospectus.global.attribute.instructor-paced',
    defaultMessage: 'Instructor-paced',
    description: 'This tells a user that the course will be paced by an instructor, not self-paced',
  },
  'prospectus.global.attribute.instructor-paced.description': {
    id: 'prospectus.global.attribute.instructor-paced.description',
    defaultMessage: 'Instructor-led on a course schedule',
    description: 'Description of what "instructor-paced" means',
  },
  'prospectus.global.attribute.language': {
    id: 'prospectus.global.attribute.language',
    description: 'Label for the product language, e.g. "English"',
    defaultMessage: 'Language',
  },
  'prospectus.global.attribute.level': {
    id: 'prospectus.global.attribute.level',
    description: 'Level as in a product\'s difficulty, such as beginner or advanced',
    defaultMessage: 'Level',
  },
  'prospectus.global.attribute.price': {
    id: 'prospectus.global.attribute.price',
    description: 'Product price',
    defaultMessage: 'Price',
  },
  'prospectus.global.attribute.self-paced': {
    id: 'prospectus.global.attribute.self-paced',
    description: 'This tells a user that the course will be self-paced, not paced by an instructor',
    defaultMessage: 'Self-paced',
  },
  'prospectus.global.attribute.self-paced.description': {
    id: 'prospectus.global.attribute.self-paced.description',
    defaultMessage: 'Progress at your own speed',
    description: 'Description of what "self-paced" means',
  },
  'prospectus.global.attribute.subject': {
    id: 'prospectus.global.attribute.subject',
    description: 'Label for the product subject, e.g. "Engineering"',
    defaultMessage: 'Subject',
  },
  'prospectus.global.auth.sign-in': {
    id: 'prospectus.global.auth.sign-in',
    defaultMessage: 'Sign in',
    description: 'Sign in link text - when the user is logged out',
  },
  'prospectus.global.auth.sign-out': {
    id: 'prospectus.global.auth.sign-out',
    description: 'Link text for the Sign-out link in the menu for logged-in users',
    defaultMessage: 'Sign Out',
  },
  'prospectus.global.course.about': {
    id: 'prospectus.global.course.about',
    description: 'Heading to introduce a description of a course',
    defaultMessage: 'About this course',
  },
  'prospectus.global.course.curriculum': {
    id: 'prospectus.global.course.curriculum',
    description: 'Title for the curriculum section on the course about page.',
    defaultMessage: 'Course curriculum',
  },
  'prospectus.global.course.enroll': {
    id: 'prospectus.global.course.enroll',
    defaultMessage: 'Enroll',
    description: 'This is the label on an enroll button that will enroll the user in the course',
  },
  'prospectus.global.course.enroll-now': {
    id: 'prospectus.global.course.enroll-now',
    description: 'Course "Enroll now" CTA button text',
    defaultMessage: 'Enroll now',
  },
  'prospectus.global.course.free': {
    id: 'prospectus.global.course.free',
    description: 'Denoting no cost',
    defaultMessage: 'Free',
  },
  'prospectus.global.course.modes.header': {
    id: 'prospectus.global.course.modes.header',
    description: 'Heading for the diagram that will show a user the differences between verified and audit track',
    defaultMessage: 'Ways to take this course',
  },
  'prospectus.global.course.outcome': {
    id: 'prospectus.global.course.outcome',
    description: 'Heading to introduce the desired outcome of a course',
    defaultMessage: 'What you\'ll learn',
  },
  'prospectus.global.course.partner-logo': {
    id: 'prospectus.global.course.partner-logo',
    description: 'This is alt text for a partner\'s logo image',
    defaultMessage: '{partnerName} Logo',
  },
  'prospectus.global.course.play-video': {
    id: 'prospectus.global.course.play-video',
    description: 'The text that appears in the button that plays the hero video',
    defaultMessage: 'Play video',
  },
  'prospectus.global.course.request-more-info': {
    id: 'prospectus.global.course.request-more-info',
    description: 'Course about `Request more info` CTA button text',
    defaultMessage: 'Request more info',
  },
  'prospectus.global.course.share': {
    id: 'prospectus.global.course.share',
    defaultMessage: 'Share this course',
    description: 'Header for social media links on a course detail page',
  },
  'prospectus.global.course.start-date': {
    id: 'prospectus.global.course.start-date',
    description: 'This describes the start date of a course.',
    defaultMessage: 'Starts {startDate}',
  },
  'prospectus.global.course.syllabus': {
    id: 'prospectus.global.course.syllabus',
    description: 'Heading to introduce the syllabus of a course',
    defaultMessage: 'Syllabus',
  },
  'prospectus.global.getsmarter.current-tab': {
    id: 'prospectus.global.get-smarter-current-tab',
    description: 'Notice that the user will be taken to an external website in the current tab',
    defaultMessage: 'You will be taken to GetSmarter in the current tab.',
  },
  'prospectus.global.getsmarter.why': {
    id: 'prospectus.global.getsmarter.why',
    description: 'A link that brings the user to the getsmarter section.',
    defaultMessage: 'Why GetSmarter?',
  },
  'prospectus.global.learn-more': {
    id: 'prospectus.global.learn-more',
    description: 'Label for a button to learn more about a course, program, etc.',
    defaultMessage: 'Learn more',
  },
  'prospectus.global.links.affiliates': {
    id: 'prospectus.global.links.affiliates',
    description: 'The label for the link to the edX affiliates page.',
    defaultMessage: 'Affiliates',
  },
  'prospectus.global.links.careers': {
    id: 'prospectus.global.links.careers',
    defaultMessage: 'Careers',
    description: 'The label for the link to the edX Careers page.',
  },
  'prospectus.global.links.connect.heading': {
    id: 'prospectus.global.links.connect.heading',
    description: 'Heading for the connect links section of the footer.',
    defaultMessage: 'Connect',
  },
  'prospectus.global.links.connect.blog': {
    id: 'prospectus.global.links.connect.blog',
    description: 'The label for the link to the edX blog.',
    defaultMessage: 'Blog',
  },
  'prospectus.global.links.connect.contact-us': {
    id: 'prospectus.global.links.connect.contact-us',
    description: 'The label for the link to the contact edX page.',
    defaultMessage: 'Contact Us',
  },
  'prospectus.global.links.connect.help-center': {
    id: 'prospectus.global.links.connect.help-center',
    description: 'The label for the link to the edX help center.',
    defaultMessage: 'Help Center',
  },
  'prospectus.global.links.connect.media-kit': {
    id: 'prospectus.global.links.connect.media-kit',
    description: 'The label for the link to the edX media kit page.',
    defaultMessage: 'Media Kit',
  },
  'prospectus.global.links.edx-for-business': {
    id: 'prospectus.global.links.edx-for-business',
    description: 'The label for the link to the edX for business page.',
    defaultMessage: 'edX For Business',
  },
  'prospectus.global.links.home': {
    id: 'prospectus.global.links.home',
    description: 'Label for a link to the edX home page.',
    defaultMessage: 'Home',
  },
  'prospectus.global.links.legal.a11y-policy': {
    id: 'prospectus.global.links.legal.a11y-policy',
    description: 'The label for the link to the edX accessibility policy page.',
    defaultMessage: 'Accessibility Policy',
  },
  'prospectus.global.links.legal.heading': {
    id: 'prospectus.global.links.legal.heading',
    description: 'Heading for the legal links section',
    defaultMessage: 'Legal',
  },
  'prospectus.global.links.legal.modern-slavery-statement': {
    id: 'prospectus.global.links.legal.modern-slavery-statement',
    description: 'The label for the link to the edX modern slavery statement page.',
    defaultMessage: 'Modern Slavery Statement',
  },
  'prospectus.global.links.legal.privacy-policy': {
    id: 'prospectus.global.links.legal.privacy-policy',
    description: 'The label for the link to the edX privacy policy page.',
    defaultMessage: 'Privacy Policy',
  },
  'prospectus.global.links.legal.sitemap': {
    id: 'prospectus.global.links.legal.sitemap',
    description: 'The label for the link to the edX sitemap page.',
    defaultMessage: 'Sitemap',
  },
  'prospectus.global.links.legal.terms-of-service': {
    id: 'prospectus.global.links.legal.terms-of-service',
    description: 'The label for the link to the edX terms of service page.',
    defaultMessage: 'Terms of Service & Honor Code',
  },
  'prospectus.global.links.legal.trademark-policy': {
    id: 'prospectus.global.links.legal.trademark-policy',
    description: 'The label for the link to the edX trademark policy page.',
    defaultMessage: 'Trademark Policy',
  },
  'prospectus.global.links.news': {
    id: 'prospectus.global.links.news',
    description: 'The label for the link to the edX news page.',
    defaultMessage: 'News',
  },
  'prospectus.global.links.open-edx': {
    id: 'prospectus.global.links.open-edx',
    description: 'The label for the link to the open edX site.',
    defaultMessage: 'Open edX',
  },
  'prospectus.global.links.subject': {
    id: 'prospectus.global.links.subject',
    description: 'Links user to subject page',
    defaultMessage: 'Courses by Subject',
  },
  'prospectus.global.mobile.apple-download': {
    id: 'prospectus.global.apple-download',
    description: 'Label for a link to download the edX app on the Apple App Store',
    defaultMessage: 'Download on the App Store',
  },
  'prospectus.global.mobile.google-download': {
    id: 'prospectus.global.google-download',
    description: 'Label for a link to download the edX app on Google Play',
    defaultMessage: 'Get it on Google Play',
  },
  'prospectus.global.new': {
    id: 'prospectus.global.new',
    description: 'Label indicating that an item is new',
    defaultMessage: 'New',
  },
  'prospectus.global.product-line.bachelors': {
    id: 'prospectus.global.product-line.bachelors',
    description: 'Title for the Bachelor\'s Degree product line',
    defaultMessage: 'Bachelor\'s Degree',
  },
  'prospectus.global.product-line.bachelors.plural': {
    id: 'prospectus.global.product-line.bachelors.plural',
    description: 'Plural version of Bachelor\'s Degree product line',
    defaultMessage: 'Bachelor\'s Degrees',
  },
  'prospectus.global.product-line.bachelors.description': {
    id: 'prospectus.global.product-line.bachelors.description',
    description: 'Description for Bachelor\'s Degree product line',
    defaultMessage: 'Begin or complete a degree; fully online',
  },
  'prospectus.global.product-line.boot-camp': {
    id: 'prospectus.global.product-line.boot-camp',
    description: 'Title for the Boot Camp product line',
    defaultMessage: 'Boot Camp',
  },
  'prospectus.global.product-line.boot-camp.plural': {
    id: 'prospectus.global.product-line.boot-camp.plural',
    description: 'Plural version of Boot Camp product line',
    defaultMessage: 'Boot Camps',
  },
  'prospectus.global.product-line.boot-camp.description': {
    id: 'prospectus.global.product-line.boot-camp.description',
    description: 'Description for Boot Camp product line',
    defaultMessage: 'Intensive, hands-on, project-based training',
  },
  'prospectus.global.product-line.certificate': {
    id: 'prospectus.global.product-line.certificate',
    description: 'Title for the Certificate product line',
    defaultMessage: 'Certificate Program',
  },
  'prospectus.global.product-line.course': {
    id: 'prospectus.global.product-line.course',
    description: 'Title for Course product line',
    defaultMessage: 'Course',
  },
  'prospectus.global.product-line.course.plural': {
    id: 'prospectus.global.product-line.course.plural',
    description: 'Plural version of Course product line',
    defaultMessage: 'Courses',
  },
  'prospectus.global.product-line.doctoral-program': {
    id: 'prospectus.global.product-line.doctoral-program',
    description: 'Title for the Doctoral product line',
    defaultMessage: 'Doctoral Program',
  },
  'prospectus.global.product-line.executive-education': {
    id: 'prospectus.global.product-line.executive-education',
    description: 'Title for the Executive Education product line',
    defaultMessage: 'Executive Education',
  },
  'prospectus.global.product-line.executive-education.description': {
    id: 'prospectus.global.product-line.executive-education.description',
    description: 'Description for Executive Education product line',
    defaultMessage: 'Expert-led, fully supported courses that build career-critical skills',
  },
  'prospectus.global.product-line.licensure-program': {
    id: 'prospectus.global.product-line.licensure-program',
    description: 'Title for the Licensure product line',
    defaultMessage: 'Licensure Program',
  },
  'prospectus.global.product-line.masters': {
    id: 'prospectus.global.product-line.masters',
    description: 'Title for the Master\'s Degree product line',
    defaultMessage: 'Master\'s Degree',
  },
  'prospectus.global.product-line.masters.plural': {
    id: 'prospectus.global.product-line.masters.plural',
    description: 'Plural version of the Master\'s Degree product line',
    defaultMessage: 'Master\'s Degrees',
  },
  'prospectus.global.product-line.masters.description': {
    id: 'prospectus.global.product-line.masters.description',
    description: 'Description for Master\'s Degree product line',
    defaultMessage: 'Online degree programs from top universities',
  },
  'prospectus.global.product-line.microbachelors': {
    id: 'prospectus.global.product-line.microbachelors',
    description: 'Title for the MicroBachelors® Program product line',
    defaultMessage: 'MicroBachelors® Program',
  },
  'prospectus.global.product-line.microbachelors.plural': {
    id: 'prospectus.global.product-line.microbachelors.plural',
    description: 'Plural version of the MicroBachelors® Program product line',
    defaultMessage: 'MicroBachelors® Programs',
  },
  'prospectus.global.product-line.micromasters': {
    id: 'prospectus.global.product-line.micromasters',
    description: 'Title for the MicroMasters® Program product line',
    defaultMessage: 'MicroMasters® Program',
  },
  'prospectus.global.product-line.micromasters.plural': {
    id: 'prospectus.global.product-line.micromasters.plural',
    description: 'Plural version of the MicroMasters® Program product line',
    defaultMessage: 'MicroMasters® Programs',
  },
  'prospectus.global.product-line.program': {
    id: 'prospectus.global.product-line.program',
    description: 'Title for Program product line',
    defaultMessage: 'Program',
  },
  'prospectus.global.product-line.program.plural': {
    id: 'prospectus.global.product-line.program.plural',
    description: 'Plural version of Program product line',
    defaultMessage: 'Programs',
  },
  'prospectus.global.product-line.professional-certificate': {
    id: 'prospectus.global.product-line.professional-certificate',
    description: 'Title for the Professional Certificate product line',
    defaultMessage: 'Professional Certificate',
  },
  'prospectus.global.product-line.professional-certificate.plural': {
    id: 'prospectus.global.product-line.professional-certificate.plural',
    description: 'Plural version of the Professional Certificate product line',
    defaultMessage: 'Professional Certificates',
  },
  'prospectus.global.search.clear-query': {
    id: 'prospectus.global.search.clear-query',
    description: 'Screen reader text for the button which clears a search query.',
    defaultMessage: 'Clear your search query',
  },
  'prospectus.global.search.placeholder': {
    id: 'prospectus.global.search.placeholder',
    description: 'Placeholder text in a search input field',
    defaultMessage: 'What do you want to learn?',
  },
  'prospectus.global.search.title': {
    id: 'prospectus.global.search.title',
    description: 'Title for the search section',
    defaultMessage: 'Search',
  },
  'prospectus.global.search.view-all-results': {
    id: 'prospectus.global.search.view-all-results',
    description: 'Button text to take users to the full page of search results for their query',
    defaultMessage: 'View all results',
  },
  'prospectus.global.show-all': {
    id: 'prospectus.global.show-all',
    defaultMessage: 'show all',
    description: 'Label for expansion button to show all content',
  },
  'prospectus.global.show-more': {
    id: 'prospectus.global.show-more',
    description: 'Label for expansion button to show more content',
    defaultMessage: 'Show more',
  },
  'prospectus.global.show-less': {
    id: 'prospectus.global.show-less',
    description: 'Label for collapse button to show less content',
    defaultMessage: 'Show less',
  },
  'prospectus.global.sr-text.details': {
    id: 'prospectus.card.details',
    description: 'Screenreader description for more details about a course',
    defaultMessage: 'Details',
  },
  'prospectus.global.sr-text.new-tab': {
    id: 'prospectus.global.sr-text.new-tab',
    description: 'Screen reader text to open a link in a new tab',
    defaultMessage: 'Opens a link in a new tab',
  },
  'prospectus.global.title.about': {
    id: 'prospectus.global.title.about',
    description: 'Title for an "About" section',
    defaultMessage: 'About',
  },
  'prospectus.global.title.certificate': {
    id: 'prospectus.global.title.certificate',
    description: 'Title for a section about the course certificate',
    defaultMessage: 'Certificate',
  },
  'prospectus.global.title.curriculum': {
    id: 'prospectus.global.title.curriculum',
    description: 'Title for the curriculum section',
    defaultMessage: 'Curriculum',
  },
  'prospectus.global.title.faqs': {
    id: 'prospectus.global.title.faqs',
    description: 'Header text for Frequently Asked Questions',
    defaultMessage: 'Frequently Asked Questions',
  },
  'prospectus.global.title.faqs.abbreviated': {
    id: 'prospectus.global.title.faqs.abbreviated',
    description: 'Header text for Frequently Asked Questions, abbreviated',
    defaultMessage: 'FAQs',
  },
  'prospectus.global.title.get-started': {
    id: 'prospectus.global.title.get-started',
    defaultMessage: 'Get Started',
    description: 'Heading for the getting started with the program section of the page.',
  },
  'prospectus.global.title.instructors': {
    id: 'prospectus.global.title.instructors',
    description: 'Title for a section about instructors for a course',
    defaultMessage: 'Instructors',
  },
  'prospectus.global.title.schools-and-partners': {
    id: 'prospectus.global.title.schools-and-partners',
    description: 'Title for schools and partners section',
    defaultMessage: 'Schools and Partners',
  },
  'prospectus.program.detail.main.ofac.question': {
    id: 'prospectus.program.detail.main.ofac.question',
    description: 'This is the question for an FAQ-like section about possible location restrictions on programs.',
    defaultMessage: 'Who can take this program?',
  },
  'prospectus.program.detail.main.ofac.answer': {
    id: 'prospectus.program.detail.main.ofac.answer',
    description: 'This is a description of the legal restrictions to taking this particular program.',
    defaultMessage: 'Unfortunately, learners residing in one or more of the following countries or regions will not be able to register for this program: Iran, Cuba and the Crimea region of Ukraine. While edX has sought licenses from the U.S. Office of Foreign Assets Control (OFAC) to offer our programs to learners in these countries and regions, the licenses we have received are not broad enough to allow us to offer this program in all locations. edX truly regrets that U.S. sanctions prevent us from offering all of our programs to everyone, no matter where they live.',
  },
});

export default messages;
